import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withConfig } from 'Context/ConfigContext';

import NoMatchView from '../../Components/NoMatch';

class NoMatchRoute extends Component {
  render() {
    const {
      history,
      appConfig: { landingRoute = '/my-courses' },
    } = this.props;
    return (
      <NoMatchView
        onCourseClick={() => {
          history.push(landingRoute);
        }}
      />
    );
  }
}

NoMatchRoute.propTypes = {
  appConfig: PropTypes.shape({
    landingRoute: PropTypes.string,
  }),
};

export default withConfig(NoMatchRoute);
